<template>
  <div :class="{ 'disable-node': disabled }">
    <div class="d-flex justify-space-between">Marque as áreas afetadas</div>
    <div class="d-flex mt-6" :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }" v-if="isParameterLoaded">
      <atopic-dermatitis-body-model
        v-model="modelValue.areas_afetadas"
        height="600px"
        class="ma-6 d-flex justify-center"
        style="flex-basis: 50%"
        width="100%"
        v-if="isPatientAdult"
        :style="{
          order: $vuetify.breakpoint.smAndDown ? 4 : 'auto',
        }"
        :read-only="disabled"
      />
      <atopic-dermatitis-child-body
        v-model="modelValue.areas_afetadas"
        height="600px"
        class="ma-6 d-flex justify-center"
        style="flex-basis: 50%"
        width="100%"
        v-else
        :style="{
          order: $vuetify.breakpoint.smAndDown ? 4 : 'auto',
        }"
        :read-only="disabled"
      />
      <v-divider
        :vertical="$vuetify.breakpoint.mdAndUp"
        :class="{
          'ml-auto': $vuetify.breakpoint.mdAndUp,
          'my-4': $vuetify.breakpoint.smAndDown,
        }"
        :style="{
          order: $vuetify.breakpoint.smAndDown ? 2 : 'auto',
        }"
      />
      <div
        class="d-flex flex-column"
        :class="{ 'pl-12': $vuetify.breakpoint.mdAndUp }"
        :style="{
          'flex-basis': $vuetify.breakpoint.smAndDown ? 'auto' : '50%',
          order: $vuetify.breakpoint.smAndDown ? 1 : 'auto',
        }"
      >
        <span class="font-weight-bold text-h6 mb-2">Áreas afetadas</span>

        <span v-if="affectedAreas.length === 0">Sem lesões</span>
        <div class="d-flex flex-column my-2">
          <span v-for="area in affectedAreas" :key="area.key" class="d-flex flex-column mt-1"> {{ area.label }}</span>
        </div>
      </div>
    </div>
    <atopic-dermatitis-symptom-level v-if="isParameterLoaded" :disabled="disabled" v-model="modelValue.niveis_sintoma">
    </atopic-dermatitis-symptom-level>
  </div>
</template>
<script>
import AtopicDermatitisBodyModel from '@/components/AttendanceForm/atopicdermatitis/AtopicDermatitisBodyModel.vue'
import AtopicDermatitisChildBody from '@/components/AttendanceForm/atopicdermatitis/AtopicDermatitisChildBody.vue'
import AtopicDermatitisSymptomLevel
  from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Scores/AtopicDermatitisSymptomLevel.vue'
import { AGE_BREAKPOINTS } from '@/components/AttendanceForm/general/constants/age'
import { createNamespacedHelpers } from 'vuex'
import { cloneDeep, isEmpty } from 'lodash'

const {
  mapActions: newAttendanceFormActions,
  mapMutations: newAttendanceFormMutations,
  mapGetters: newAttendanceFormGetters,
} = createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'ScoradParameter',
  components: { AtopicDermatitisBodyModel, AtopicDermatitisChildBody, AtopicDermatitisSymptomLevel },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    const { questions } = (await this.getParameter('atopic-dermatitis:scorad')) ?? {}
    if (questions) {
      this.modelValue = cloneDeep(questions)
    }
    this.isParameterLoaded = true
  },
  data() {
    const baseValue = {
      areas_afetadas: {},
      niveis_sintoma: {},
    }
    const modelValue = isEmpty(this.value) ? baseValue : cloneDeep(this.value)

    return {
      modelValue,
      isParameterLoaded: false,
    }
  },
  computed: {
    ...newAttendanceFormGetters(['patientData', 'extraAnswers']),
    isPatientAdult() {
      return this.patientData.age >= AGE_BREAKPOINTS.child
    },
    affectedAreas() {
      return Object.values(this.modelValue.areas_afetadas).filter((a) => a.selected)
    },
  },
  methods: {
    ...newAttendanceFormActions(['getParameter']),
    ...newAttendanceFormMutations(['updateParameter']),
    parseScore() {
      const symptomKeys = ['eritema', 'edema', 'exsudacao', 'escoriacoes', 'xerose', 'liquenificacao']

      if (
        this.modelValue.areas_afetadas.area_total == null ||
        symptomKeys.some((key) => this.modelValue.niveis_sintoma[key].value == null)
      ) {
        return '?'
      }

      const affectedArea = Number(this.modelValue.areas_afetadas.area_total) || 0
      const intensity = symptomKeys.reduce(
        (result, currentSymptomKey) => result + (this.modelValue.niveis_sintoma[currentSymptomKey].value ?? 0),
        0,
      )

      const a = affectedArea / 5
      const b = 7 * (intensity / 2)
      return a + b
    },
  },
  watch: {
    /** @type {WatchOptionsWithHandler<Record<number, string>>} */
    modelValue: {
      handler(value) {
        this.updateParameter({
          parameter: 'atopic-dermatitis:scorad',
          value: { score: this.parseScore(), questions: value },
        })
      },
      deep: true,
    },
  },
}
</script>
<style scoped></style>
